import { sendPrescription } from "../services/send-prescription";
import { usePrescriptionMutation } from "./use-prescription-mutation";

export function useSendPrescription() {
  return usePrescriptionMutation({
    mutationFn: sendPrescription,
    successMessage: "Prescription sent successfully",
    errorMessage: "Failed to send prescription",
  });
}
